(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/game-handler/assets/javascripts/ticket-contentlist-mapper.js') >= 0) return;  svs.modules.push('/components/ticketgames/game-handler/assets/javascripts/ticket-contentlist-mapper.js');
let logger;
const allowedTicketGameCategories = ['triss', 'skrapspel'];

const mapImage = (imgObj, images, type) => {
  let imageSrc = null;

  const {image = {}, description = ''} = imgObj;
  try {
    imageSrc = images.find(({ typeName }) => typeName === (image.name || image.typeName));
  } catch (e) {
    logger.warn(`Failed to find image ${JSON.stringify(image)} for game ${type}`);
  }
  return {
    image: imageSrc && createImageV2(imageSrc),
    description
  };
};

const createImageV2 = (image) => {
  return {
    ...image,
    sizes: '(min-width: 640px) 640px, 100vw',
    aspectRatio: {
      height: image.height,
      width: image.width
    },
    altText: image.altText || '',
    title: image.title || ''
  };
};

const getTheme = ({ theme, type}, themes = []) => {
  const activeTheme = themes?.find(({ themeName }) => themeName?.toLowerCase() === theme?.toLowerCase());
  if (activeTheme) {
    return activeTheme;
  }
  const backupTheme = themes.length > 0 && themes[0];
  logger.warn(`did not find theme ${theme} for ${type}, using first theme: ${ JSON.stringify(backupTheme) || 'no themes configured'}`);
  return backupTheme;
};

const mapPriceByTicketType = (type) => {
  let mapProductType;
  if (svs.isServer) {
    const { core: trinidad } = require('@svenskaspelab/trinidad-core');
    mapProductType = trinidad.components.require('ticketgames', 'ticket-mappings')?.mapProductType;
  } else {
    mapProductType = svs.ticketgames.ticketMappings.productMappings.mapProductType;
  }
  const shortName = mapProductType(type);

  if (!shortName) {
    return;
  }
  switch (shortName) {
    case 'trissadventskalender':
      return 150;
    case 'skrap7an':
    case 'skrapbingo':
    case 'skrapkryss':
    case 'skrapkeno':
    case 'pacman':
    case 'triss30':
      return 30;
    case 'biltriss': 
    case 'triss40':
      return 40;
    case 'dubbeltriss':
      return 60;
    case 'minitriss':
      return 10;
    default:
  }
};

const mapScratchTicketsFromContentList = (games = [], contentList = [], voucherConfigs = [], softLaunchEnabled = false) =>
  contentList
    .reduce((list, contentListGame) => {
      const skipLeiaConfig = games.length === 0;
      const { properties: { cnt_ticketGameConfig: config, cnt_ticketGameCategory: ticketGameCategory }, images = []} = contentListGame;
      if (!allowedTicketGameCategories.includes(ticketGameCategory)) {
        return list;
      }
      const { gameProvider, category, name, softLaunchTicket } = JSON.parse(config);

      if (skipLeiaConfig && (softLaunchEnabled || !softLaunchTicket)) {
        list.push({...gameProvider.config, ...category.config, images, name, branding: ticketGameCategory?.toLowerCase() });
        return list;
      }

      const type = gameProvider?.config?.leiaType ?? null;
      const leiaConfig = games.find((game) => game.type === type);
      if (leiaConfig && (softLaunchEnabled || !softLaunchTicket)) {
        list.push({...gameProvider.config, ...category.config, leiaConfig, images, name, branding: ticketGameCategory?.toLowerCase() });
      } else {
        !softLaunchTicket && logger.warn(`did not find match for ${type || name}`);
      }
      return list;
    }, [])
    .map((config) => {
      const {images, leiaConfig = null, ...gameConfig} = config;
      const gameCode = leiaConfig?.type || gameConfig.leiaType;
      const {height, width, margin, themes, ticketPitch, customBg, seoTitle: title} = gameConfig;
      const foundVoucher = voucherConfigs?.find(({ onlineTicketType }) => onlineTicketType?.includes(gameCode));
      const theme = getTheme(
        leiaConfig || { type: gameCode, theme: themes[0].themeName }, 
        themes);
      return {
        ...{
          type: gameCode,
          price: mapPriceByTicketType(gameCode),
          ...leiaConfig
        },
        ...gameConfig,
        ...{
          ...theme,
          skins: theme?.skins?.map((obj) => mapImage(obj, images, gameCode)) ?? []
        },
        customBg: customBg && mapImage({ image: { name: customBg.name }}, images, gameCode),
        ticketPitch: ticketPitch && mapImage({ image: { name: ticketPitch.name }}, images, gameCode),
        claimableAs: foundVoucher?.onlineTicketType?.split(',') || [],
        voucherId: foundVoucher?.voucherConfigId || null,
        variations: theme?.skins?.length,
        onlineOnly: foundVoucher?.onlineOnly || false,
        themes: themes?.map(({skins, themeName}) => ({themeName, skins: skins?.map((obj) => mapImage(obj, images, gameCode))})),
        title,
        isLeia: true,
        height: parseInt(height, 10),
        width: parseInt(width, 10),
        margin: parseInt(margin, 10)
      };
    }) ?? [];

if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  const ContentUrlBuilder = trinidad.components.require('content', 'shared').apiUtils.ContentUrlBuilder;
  const ttlCache = trinidad.ttlcache;
  const cache = new ttlCache();
  const cacheTime = 30 * 1000; 
  logger = trinidad.logger('component:game-handler');

  const getAllTicketGames = async (req) => {
    const cacheId = 'allTickets';
    const cachedResult = cache.get(cacheId);
    if (cachedResult) {
      logger.info(`skip fetch and use cache for allTickets`, req);
      return cachedResult;
    }
    try {
      const data = await trinidad.jupiter.callAsync({
        method: 'GET',
        path: new ContentUrlBuilder(req, 'basicfilter')
          .addParams({
            channel: 'tur',
            contentType: 'cnt:ticketGame',
            count: 200
          }).build(),
        req
      });
      cache.set(cacheId, data.result, cacheTime);
      return data.result;
    } catch (err) {
      logger.error(`Failed to fetch ticketGames from CMS`, JSON.stringify(err), req);
      throw new Error(err);
    }
  };

  const getContentList = async (req, contentListId) => {
    const cachedResult = cache.get(contentListId);
    if (cachedResult) {
      logger.info(`skip fetch and use cache for contentListId ${contentListId}`, req);
      return cachedResult;
    }
    try {
      if (!contentListId) {
        logger.info('No content list configured in module', req);
      }
      const data = await trinidad.jupiter.callAsync({
        method: 'GET',
        path: new ContentUrlBuilder(req, 'listfilter')
          .addParams({
            listId: contentListId,
            count: 100,
            channel: 'tur'
          })
          .build(),
        req
      });
      cache.set(contentListId, data.result, cacheTime);
      return data.result;
    } catch (err) {
      logger.error(`Failed to fetch content list with id ${contentListId}`, JSON.stringify(err), req);
      throw new Error(err);
    }
  };

  module.exports = {
    mapScratchTicketsFromContentList,
    getContentList,
    getAllTicketGames
  };
} else {
  logger = svs.core.log.getLogger('components:game-handler');
  setGlobal('svs.ticketgames.gameHandler.mapScratchTicketsFromContentList', mapScratchTicketsFromContentList);
}



 })(window);